import { createReducer } from '@reduxjs/toolkit';
import * as actions from '@/store/actions';

const initialState = false;

export default createReducer(initialState, {
	[actions.setConfirmSoilInvestigationsDeletionDialogOpen.type]: (draft, { payload }): boolean => payload,
});
